import { useNavigate } from "fusion-plugin-react-router";
import { FiChevronLeft } from "react-icons/fi";
import Button from "../../../shared/components/Button";
import { scrollToTop } from "../../../shared/utils/scrollUtils";

const PortalBackButton = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-my-3 tw-flex tw-w-full tw-items-end tw-justify-between">
      <Button
        type="button"
        aria-label="Previous step"
        variant="back"
        size="circle"
        onClick={() => {
          navigate("/landing");
          scrollToTop();
        }}
        trailingIcon={
          <FiChevronLeft
            className="tw-h-[22px] tw-w-[22px]"
            strokeWidth={2.4}
            aria-hidden="true"
          />
        }
      />
    </div>
  );
};

export default PortalBackButton;
